import ajaxRequest from './ajax'
import qs from "qs"
export const insert_or_update_help = params => {
  return ajaxRequest.post("help/insert_or_update_help", params)
}

export const admin_search_help = params => {
  return ajaxRequest.get("help/admin_search_help?" + qs.stringify(params))
}

export const get_help_detail = params => {
  return ajaxRequest.get("help/get_help_detail?"+ qs.stringify(params))
}

export const upload_help_attachment = params => {
  return ajaxRequest.post('help/upload_help_attachment',params.data, {
    Token:params.token
  } )
}

// 参会人 说明，或者播放地址
export const user_search_help = params => {
  return ajaxRequest.get('help/user_search_help?' + qs.stringify(params));
}

// 用户手册排序
export const update_help_sort = params => {
  return ajaxRequest.post('help/update_help_sort',params)
}




// WEBPACK FOOTER //
// ./src/api/little_helper.js